"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryChoiceSchema = exports.default = void 0;
var BinaryChoice_1 = require("./BinaryChoice");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(BinaryChoice_1).default; } });
Object.defineProperty(exports, "BinaryChoiceSchema", { enumerable: true, get: function () { return BinaryChoice_1.BinaryChoiceSchema; } });
//# sourceMappingURL=index.js.map